<ng-container *transloco="let t">
  <div fxLayout>
    <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'SETTINGS.SETTINGS' | transloco">
      <sbnb-settings-subnav></sbnb-settings-subnav>
    </sbnb-subnav>

    <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
      <app-feature-flag-tabs>
        <sbnb-page-header navTabs>
          <h2 fxLayout fxLayoutAlign="space-apart center w-full">
            <span fxFlex class="w-full">General</span>
            <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
          </h2>
        </sbnb-page-header>
        <h2 fxLayout fxLayoutAlign="space-apart center w-full">
          <span fxFlex class="w-full">General</span>
          <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
        </h2>
      </app-feature-flag-tabs>

      <!-- Loading state-->
      <mat-spinner *ngIf="loading" [diameter]="32"></mat-spinner>

      <ng-container *ngIf="data && !loading">
        <strong>Language (User interface)</strong>

        <mat-form-field class="fw">
          <mat-select
            [(ngModel)]="activeLanguage"
            [disabled]="(canChangeLanguage$ | async) === false"
            placeholder="Select a language">
            <mat-option *ngFor="let lang of availableLanguages()" [value]="lang">
              {{ t('LANGUAGE.' + (LanguageLabels[lang] | uppercase)) }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <strong>Timezone</strong>
        <mat-form-field class="fw">
          <mat-select [(ngModel)]="data.timezone" placeholder="Select a timezone">
            <mat-option *ngFor="let tz of fieldsMeta.timezones" [value]="tz.key">
              {{ tz.key }} ({{ tz.value }})
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="setting-time-display">
          <strong>Time format</strong>
          <mat-radio-group [(ngModel)]="data.uses_24_hour_format">
            <div fxLayout="column" fxLayoutGap="12px">
              <mat-radio-button [value]="false">Display times in 12-hour format (e.g. 3:30pm)</mat-radio-button>
              <mat-radio-button [value]="true">Display times in 24-hour format (e.g. 15:30)</mat-radio-button>
            </div>
          </mat-radio-group>
        </div>

        <div class="setting-time-display">
          <strong>Start of week</strong>
          <mat-radio-group [(ngModel)]="data.week_starts_on">
            <div fxLayout="column" fxLayoutGap="12px">
              <mat-radio-button [value]="'sunday'">Start the week on Sunday</mat-radio-button>
              <mat-radio-button [value]="'monday'">Start the week on Monday</mat-radio-button>
            </div>
          </mat-radio-group>
        </div>

        <div fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
          <mat-slide-toggle [(ngModel)]="data.beta_features_enabled" [disabled]="!canManageBetaFeatures()">
            <strong>Enable experimental (beta) features</strong>
          </mat-slide-toggle>
        </div>
        <span class="card__collapsed-helper-text" *ngIf="!canManageBetaFeatures()">
          (Only owners and team admins switch this on or off.)
        </span>
        <span class="card__collapsed-helper-text">
          When switched on, you and your team will start getting early access to features that we are still working on
          but aren't ready to share with every single one of our customers yet. This setting applies to every person on
          your team.
        </span>

        <sbnb-button [loading]="saving" size="mini" label="Save changes" (clicked)="save()"></sbnb-button>
      </ng-container>

      <sbnb-app-version class="block mt-16"></sbnb-app-version>
    </main>
  </div>

  <sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Settings'">
    <sbnb-settings-subnav></sbnb-settings-subnav>
  </sbnb-mobile-sidebar>
</ng-container>
